import { Component } from '@theme/component';

/**
 * "See full build sheet" — reveals the spec rows past the fold.
 *
 * Ports WP's `collapseomatic` expander (docs/product-page.md §2.9). Live shows
 * the first three spec rows and hides the rest; the row count is a section
 * setting here, so the markup ships with the extra rows already present and
 * `hidden`, and this only flips the attribute. That keeps every spec in the
 * DOM for search engines and for users without JS — nothing is fetched on
 * expand.
 *
 * @typedef {object} Refs
 * @property {HTMLButtonElement} toggle - The expander button.
 * @property {HTMLElement} toggleLabel - Its label span, swapped on toggle.
 *
 * @extends {Component<Refs>}
 */
class ZagerBuildSheetComponent extends Component {
  requiredRefs = ['toggle', 'toggleLabel'];

  #expanded = false;

  /** Shows or hides every folded row, and swaps the button label. */
  toggle() {
    this.#expanded = !this.#expanded;

    for (const row of this.querySelectorAll('.zager-product-specs__row--folded')) {
      row.toggleAttribute('hidden', !this.#expanded);
    }

    const { toggle, toggleLabel } = this.refs;
    toggle.setAttribute('aria-expanded', String(this.#expanded));

    const label = this.#expanded ? this.dataset.collapseLabel : this.dataset.expandLabel;
    if (label) toggleLabel.textContent = label;
  }
}

if (!customElements.get('zager-build-sheet-component')) {
  customElements.define('zager-build-sheet-component', ZagerBuildSheetComponent);
}
